module.exports = __webpack_public_path__ + "static/media/callback.d17f6f72.jpg";